import { create } from 'zustand';
import { authAPI } from '../api/services';

export const useAuthStore = create((set) => ({
  user: null,
  token: localStorage.getItem('token') || null,
  loading: false,
  error: null,

  register: async (userData) => {
    set({ loading: true, error: null });
    try {
      const response = await authAPI.register(userData);
      set({ loading: false });
      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Registration failed';
      set({ loading: false, error: errorMsg });
      throw error;
    }
  },

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const response = await authAPI.login(email, password);
      const { access_token } = response.data;
      localStorage.setItem('token', access_token);
      set({ token: access_token, loading: false });
      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Login failed';
      set({ loading: false, error: errorMsg });
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  getCurrentUser: async () => {
    set({ loading: true });
    try {
      const response = await authAPI.getCurrentUser();
      set({ user: response.data, loading: false });
    } catch (error) {
      set({ loading: false, error: 'Failed to fetch user' });
    }
  },

  updateProfile: async (userData) => {
    set({ loading: true, error: null });
    try {
      const response = await authAPI.updateProfile(userData);
      set({ user: response.data, loading: false });
      return response.data;
    } catch (error) {
      set({ loading: false, error: 'Failed to update profile' });
      throw error;
    }
  },

  isAuthenticated: () => localStorage.getItem('token') !== null,
}));
